module.exports = __webpack_public_path__ + "img/HNS logo.5cebff76.png";